// Currency formatting utilities

export function formatCurrency(
  amount: number,
  currency: string = 'AUD',
  showSymbol: boolean = true,
): string {
  const formatter = new Intl.NumberFormat('en-AU', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return formatter.format(amount)
}

export function formatAmount(amount: number, currency: string = 'AUD'): string {
  return formatCurrency(amount, currency, true)
}

export function parseCurrency(value: string): number {
  // Remove currency symbols and thousands separators
  const cleanValue = value.replace(/[^0-9.-]/g, '')
  return parseFloat(cleanValue) || 0
}

export function formatPercentage(value: number, decimals: number = 0): string {
  return `${(value * 100).toFixed(decimals)}%`
}

export function getCurrencySymbol(currency: string): string {
  const symbols: Record<string, string> = {
    AUD: '$',
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    NZD: '$',
    CAD: '$',
    SGD: '$',
    HKD: '$',
  }
  return symbols[currency] || '$'
}
